import type { FormControlLabelProps } from "@mui/material";
import { InputLabel, Stack, Switch } from "@mui/material";
import { isEmpty } from "lodash-es";
import type { FieldValues, Path } from "react-hook-form";
import { useFormContext, useWatch } from "react-hook-form";
import type { ElementTracking } from "../../../analytics/analytics";
import { useElementTracking } from "../../../analytics/analytics";

export const CeToggle = <TFieldValues extends FieldValues>({
  label,
  name,
  onChange,
  analyticsCategory,
  labelPlacement = "start",
}: {
  label: string;
  labelPlacement?: FormControlLabelProps["labelPlacement"];
  name: Path<TFieldValues>;
  onChange: (checked: boolean) => void;
} & ElementTracking): React.JSX.Element => {
  const analyticsProps = useElementTracking(analyticsCategory, name, "toggle");
  const { control, getValues } = useFormContext<TFieldValues>();
  useWatch({ control, name });
  const value = getValues(name);
  return (
    <Stack
      direction={labelPlacement === "top" ? "column" : "row"}
      alignItems={labelPlacement === "top" ? "flex-start" : "center"}
    >
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Switch
        checked={value === true || !isEmpty(value)}
        onChange={(_, checked) => onChange(checked)}
        slotProps={{ input: { "aria-labelledby": `${name}-label`, ...analyticsProps } }}
      />
    </Stack>
  );
};
